import React, { useRef, useMemo, useCallback } from "react";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import TextBox from 'devextreme-react/text-box';
import handlePostProvideAssist from '../../Utils/handlePOST/handlePostProvideAssist'
import useFetch from '../../Hooks/useFetch';
import { useNavigate } from 'react-router-dom';
import { isMobile } from '../../Utils/media-query';


export default function ProvideAssistance({ orderId, setNotifications, onClose }) {

	const navigate = useNavigate()
		, fetch = useFetch(navigate);

	const issue = useRef('');
	const onValueChanged = (e) => {
		issue.current = e.value;
	}

	const submitAssistance = useCallback(async () => {
		const { response, isDataGood } = await handlePostProvideAssist(issue.current, orderId, fetch);
		setNotifications(response);
		if (isDataGood) {
			onClose();
		}
	}, [orderId, fetch, onClose, setNotifications]);

	const submitOptions = useMemo(() => {
		return {
			stylingMode: 'contained',
			text: "Send",
			onClick: () => { submitAssistance() }
		}
	}, [submitAssistance]);

	const cancelOptions = useMemo(() => {
		return {
			stylingMode: "outlined",
			text: 'cancel',
			onClick: () => onClose()
		}
	}, [onClose]);

	return (
		<Popup
			visible={true}
			onHiding={() => onClose()}
			hideOnOutsideClick={true}
			title="Provide Assistance"
			width={isMobile ? '100%' : '50%'}
			height="auto"
			resizeEnabled={true}
		>
			<ToolbarItem
				widget="dxButton"
				toolbar="bottom"
				location="after"
				options={cancelOptions}
			/>
			<TextBox
				spellcheck={true}
				placeholder="Type comment..."
				onValueChanged={onValueChanged}
				valueChangeEvent="input" />
			<ToolbarItem
				widget="dxButton"
				toolbar="bottom"
				location="after"
				options={submitOptions}
			/>
		</Popup>
	);
}